var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.84,
    height: 30.195,
    viewBox: "93.295 134.402 13.42 15.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.295 149.5v-1.678a3.355 3.355 0 0 1 3.355-3.355h6.71a3.355 3.355 0 0 1 3.355 3.355v1.678",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.36 137.757a3.355 3.355 0 0 1-3.355 3.355 3.355 3.355 0 0 1-3.355-3.355 3.355 3.355 0 0 1 3.355-3.355 3.355 3.355 0 0 1 3.355 3.355Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 829"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f5cbe34ae5ebb58ca73aa7cd59576260.svg";
export { ForwardRef as ReactComponent };